/* KAKAVY_APPLE_LOGO_ADDON_V1_START */
(function(){
  if(window.KAKAVY_APPLE_LOGO_ADDON_V1)return;
  window.KAKAVY_APPLE_LOGO_ADDON_V1=true;
  var ADDON_ID='50103707107570';
  var TEXT_ADDON_ID='49915109605618';
  var ADDON_TITLE='Apple Logo Customization';
  var ADDON_SKU='KAKAVY-APPLE-LOGO';
  var PROPERTY='Apple logo';
  var ADDON_PROPERTY='_KAKAVY add-on';
  var ADDON_VALUE='Apple logo customization';
  var STORE_KEY='kakavy:apple-logo:premium-leather-ipad-sleeve';
  var syncing=false,queued=false,timer=null;

  function cards(root){return Array.prototype.slice.call((root||document).querySelectorAll('[data-kakavy-apple-logo]'));}
  function checkbox(card){return card&&card.querySelector('.kakavy-apple-logo__toggle');}
  function isChecked(){var card=document.querySelector('[data-kakavy-apple-logo]');var box=checkbox(card);return Boolean(box&&box.checked);}
  function store(value){try{sessionStorage.setItem(STORE_KEY,value?'1':'0');}catch(e){}}
  function stored(){try{return sessionStorage.getItem(STORE_KEY)==='1';}catch(e){return false;}}
  function productInfo(node){return node&&node.closest?node.closest('product-info'):document.querySelector('product-info');}
  function cartForms(card){var info=productInfo(card);return info?Array.prototype.slice.call(info.querySelectorAll('form[action*="/cart/add"],form[data-type="add-to-cart-form"]')):[];}
  function syncCard(card,restore){
    var box=checkbox(card);if(!box)return;
    if(restore)box.checked=stored();
    var active=Boolean(box.checked);
    card.querySelectorAll('.kakavy-apple-logo__property').forEach(function(input){input.disabled=!active;input.value='Yes';});
    cartForms(card).forEach(function(form){
      var input=form.querySelector('input[data-kakavy-apple-property]');
      if(!input){input=document.createElement('input');input.type='hidden';input.name='properties[Apple logo]';input.setAttribute('data-kakavy-apple-property','true');form.appendChild(input);}
      input.value='Yes';input.disabled=!active;
    });
  }
  function bind(root){cards(root).forEach(function(card){var fresh=card.dataset.appleReady!=='true';card.dataset.appleReady='true';syncCard(card,fresh);});}
  document.addEventListener('change',function(event){var box=event.target&&event.target.closest&&event.target.closest('.kakavy-apple-logo__toggle');if(!box)return;var card=box.closest('[data-kakavy-apple-logo]');store(box.checked);syncCard(card,false);},true);
  document.addEventListener('variant:changed',function(){setTimeout(function(){bind(document);cards(document).forEach(function(card){syncCard(card,true);});},60);});
  document.addEventListener('shopify:section:load',function(event){bind(event.target);});
  document.addEventListener('DOMContentLoaded',function(){bind(document);});
  if(window.MutationObserver){new MutationObserver(function(){bind(document);}).observe(document.documentElement,{childList:true,subtree:true});}
  bind(document);

  function isAddUrl(url){return /\/cart\/add(\.js)?/i.test(String(url||''));}
  function isMutationUrl(url){return /\/cart\/(add|change|update|clear)(\.js)?/i.test(String(url||''));}
  function qty(value){var n=Number(value||1);return Number.isFinite(n)&&n>0?Math.floor(n):1;}
  function currentVariant(){var card=document.querySelector('[data-kakavy-apple-logo]');var forms=cartForms(card);for(var i=0;i<forms.length;i++){var input=forms[i].querySelector('[name="id"]');if(input&&input.value)return String(input.value);}return '';}
  function propsFromForm(body){var result={};body.forEach(function(value,key){var match=String(key).match(/^properties\[(.*)\]$/);if(match&&String(value||'').trim())result[match[1]]=String(value).trim();});return result;}
  function sectionFields(body,payload){if(body&&body.get){if(body.get('sections'))payload.sections=body.get('sections');if(body.get('sections_url'))payload.sections_url=body.get('sections_url');}return payload;}
  function transformObject(data){
    var selected=currentVariant();if(!selected)return data;
    if(Array.isArray(data.items)){
      var items=data.items.map(function(item){return Object.assign({},item,{properties:Object.assign({},item.properties||{})});});
      var target=items.find(function(item){return String(item.id||'')===selected;});if(!target)return data;
      target.properties[PROPERTY]='Yes';
      if(!items.some(function(item){return String(item.id||'')===ADDON_ID;}))items.push({id:ADDON_ID,quantity:qty(target.quantity),properties:{'Apple logo':'Yes','_KAKAVY add-on':ADDON_VALUE}});
      return Object.assign({},data,{items:items});
    }
    if(data&&data.id&&String(data.id)===selected){
      var main=Object.assign({},data,{sections:undefined,sections_url:undefined,properties:Object.assign({},data.properties||{})});main.properties[PROPERTY]='Yes';
      var out={items:[main,{id:ADDON_ID,quantity:qty(data.quantity),properties:{'Apple logo':'Yes','_KAKAVY add-on':ADDON_VALUE}}]};if(data.sections)out.sections=data.sections;if(data.sections_url)out.sections_url=data.sections_url;return out;
    }
    return data;
  }
  function transform(body){
    if(!isChecked()||!body)return body;
    try{
      if(window.FormData&&body instanceof FormData){var id=body.get('id');if(String(id||'')!==currentVariant())return body;var main={id:String(id),quantity:qty(body.get('quantity')),properties:propsFromForm(body)};main.properties[PROPERTY]='Yes';if(body.get('selling_plan'))main.selling_plan=body.get('selling_plan');return JSON.stringify(sectionFields(body,{items:[main,{id:ADDON_ID,quantity:main.quantity,properties:{'Apple logo':'Yes','_KAKAVY add-on':ADDON_VALUE}}]}));}
      if(window.URLSearchParams&&body instanceof URLSearchParams){return transform(new FormData(new URLSearchParams(body)));}
      if(typeof body==='string'){if(body.trim().charAt(0)==='{')return JSON.stringify(transformObject(JSON.parse(body)));var params=new URLSearchParams(body);var fd=new FormData();params.forEach(function(v,k){fd.append(k,v);});return transform(fd);}
    }catch(error){console.error(error);}
    return body;
  }
  function jsonHeaders(init){var headers=new Headers((init&&init.headers)||{});headers.set('Content-Type','application/json');if(!headers.get('Accept'))headers.set('Accept','application/json');return headers;}

  if(window.fetch&&!window.KAKAVY_APPLE_LOGO_FETCH_V1){
    window.KAKAVY_APPLE_LOGO_FETCH_V1=true;var originalFetch=window.fetch;
    window.fetch=function(input,init){var url=typeof input==='string'?input:input&&input.url;var internal=init&&init.headers&&new Headers(init.headers).get('X-KAKAVY-APPLE-INTERNAL')==='1';
      if(!internal&&isAddUrl(url)&&init&&init.body&&isChecked()){var changed=transform(init.body);if(changed!==init.body)init=Object.assign({},init,{headers:jsonHeaders(init),body:changed});}
      return originalFetch.call(this,input,init).then(function(response){if(isMutationUrl(url)&&!syncing)schedule(120);return response;});
    };
  }

  function textActive(){var card=document.querySelector('[data-kakavy-personalize],.kakavy-personalize');if(!card)return false;var box=card.querySelector('.kakavy-personalize__toggle,.kakavy-personalize__checkbox,input[type="checkbox"]');return Boolean(box&&box.checked);}
  document.addEventListener('click',function(event){
    var trigger=event.target&&event.target.closest&&event.target.closest('.shopify-payment-button__button,.shopify-payment-button__more-options,shopify-accelerated-checkout,shop-pay-wallet-button');
    if(!trigger||!isChecked()||textActive())return;var info=productInfo(trigger);var form=trigger.form||(info&&info.querySelector('form[action*="/cart/add"]'));if(!form)return;
    event.preventDefault();event.stopImmediatePropagation();
    var body=new FormData(form);fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:body}).then(function(r){if(!r.ok)throw new Error('Could not add Apple logo customization.');return r.json();}).then(function(){window.location.href='/checkout';}).catch(function(error){console.error(error);window.location.href='/cart';});
  },true);

  function getProperty(item,name){var p=item&&item.properties;if(!p)return '';if(Array.isArray(p)){for(var i=0;i<p.length;i++)if(p[i]&&p[i].name===name)return String(p[i].value||'');return '';}return String(p[name]||'');}
  function isAddon(item){return String(item&&item.variant_id||'')===ADDON_ID||String(item&&item.sku||'')===ADDON_SKU||String(item&&item.product_title||'').trim()===ADDON_TITLE;}
  async function cart(){var r=await fetch('/cart.js',{headers:{Accept:'application/json','X-KAKAVY-APPLE-INTERNAL':'1'},cache:'no-store'});if(!r.ok)throw new Error('Could not read cart.');return r.json();}
  async function post(url,data){var r=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-KAKAVY-APPLE-INTERNAL':'1'},body:JSON.stringify(data)});if(!r.ok)throw new Error('Could not synchronize Apple logo customization.');return r.json();}
  function publish(data){document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:data}}));document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{cart:data}}));if(window.FoxTheme&&FoxTheme.pubsub&&FoxTheme.pubsub.publish&&FoxTheme.pubsub.PUB_SUB_EVENTS)FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,{cart:data});}
  async function enforce(){
    if(syncing){queued=true;return;}syncing=true;queued=false;document.documentElement.setAttribute('data-kakavy-apple-integrity-active','true');
    try{var data=await cart();var required=0,addons=[];(data.items||[]).forEach(function(item){if(isAddon(item))addons.push(item);else if(/^yes$/i.test(getProperty(item,PROPERTY)))required+=Number(item.quantity||0);});var have=addons.reduce(function(sum,item){return sum+Number(item.quantity||0);},0);var changed=false;
      if(have<required){await post('/cart/add.js',{items:[{id:ADDON_ID,quantity:required-have,properties:{'Apple logo':'Yes','_KAKAVY add-on':ADDON_VALUE}}]});changed=true;}
      if(have>required){var surplus=have-required;for(var i=addons.length-1;i>=0&&surplus>0;i--){var reduce=Math.min(surplus,Number(addons[i].quantity||0));await post('/cart/change.js',{id:addons[i].key,quantity:Number(addons[i].quantity||0)-reduce});surplus-=reduce;changed=true;}}
      if(changed){data=await cart();publish(data);}markRows();
    }finally{syncing=false;document.documentElement.removeAttribute('data-kakavy-apple-integrity-active');document.documentElement.removeAttribute('data-kakavy-apple-integrity-pending');if(queued)setTimeout(enforce,60);}
  }
  function schedule(delay){document.documentElement.setAttribute('data-kakavy-apple-integrity-pending','true');if(timer)clearTimeout(timer);timer=setTimeout(function(){enforce().catch(function(error){console.error(error);document.documentElement.removeAttribute('data-kakavy-apple-integrity-pending');});},delay==null?160:delay);}
  function markRows(){document.querySelectorAll('cart-item,.cart-item,tr,li,.drawer__cart-item,.cart-drawer__item,[data-cart-item]').forEach(function(row){var text=String(row.textContent||'');if(text.indexOf(ADDON_TITLE)===-1&&text.indexOf(ADDON_SKU)===-1)return;row.setAttribute('data-kakavy-apple-addon-line','true');});}
  function style(){if(document.getElementById('kakavy-apple-integrity-style'))return;var s=document.createElement('style');s.id='kakavy-apple-integrity-style';s.textContent='[data-kakavy-apple-addon-line="true"] cart-remove-button,[data-kakavy-apple-addon-line="true"] .cart-item__remove,[data-kakavy-apple-addon-line="true"] quantity-input,[data-kakavy-apple-addon-line="true"] .quantity{display:none!important;pointer-events:none!important}html[data-kakavy-apple-integrity-pending="true"] button[name="checkout"],html[data-kakavy-apple-integrity-active="true"] button[name="checkout"]{pointer-events:none!important;opacity:.55!important}';document.head.appendChild(s);}
  document.addEventListener('DOMContentLoaded',function(){style();markRows();schedule(240);});
  style();markRows();
})();
/* KAKAVY_APPLE_LOGO_ADDON_V1_END */

/* KAKAVY_PERSONALIZATION_GLOBAL_SYNC_V1_ASSET */
(function() {
  if (window.KAKAVY_PERSONALIZATION_GLOBAL_SYNC_V1) return;
  window.KAKAVY_PERSONALIZATION_GLOBAL_SYNC_V1 = true;

  var STYLE_SUFFIX = ' + Add custom text';
  var dataLoading = false;
  var dataCallbacks = [];

  function loadVariantData(callback) {
    if (window.KAKAVY_CUSTOM_VARIANT_DATA) {
      callback();
      return;
    }
    dataCallbacks.push(callback);
    if (dataLoading) return;
    dataLoading = true;
    var script = document.createElement('script');
    script.src = '/cdn/shop/t/2/assets/kakavy-custom-variant-prices.js?v=' + Date.now();
    script.onload = function() {
      var callbacks = dataCallbacks.slice();
      dataCallbacks = [];
      callbacks.forEach(function(item) { item(); });
    };
    script.onerror = function() {
      dataCallbacks = [];
    };
    document.head.appendChild(script);
  }

  function optionNameFromInputName(name) {
    var match = (name || '').match(/^options\[(.*)\]$/);
    return (match ? match[1] : name || '').trim().replace(/-\d+$/, '').trim();
  }

  function getProductHandle(productInfo) {
    return ((productInfo.dataset.url || window.location.pathname || '').split('/products/')[1] || '').split(/[?#/]/)[0];
  }

  function parseInlineVariants(card) {
    try {
      var node = card.parentElement && card.parentElement.querySelector('[data-kakavy-personalize-variants]');
      return JSON.parse((node && node.textContent) || '[]');
    } catch (error) {
      return [];
    }
  }

  function getVariants(card, productInfo) {
    var inlineVariants = parseInlineVariants(card);
    var handle = getProductHandle(productInfo);
    var completeVariants = window.KAKAVY_CUSTOM_VARIANT_DATA && window.KAKAVY_CUSTOM_VARIANT_DATA[handle];
    if (Array.isArray(completeVariants) && completeVariants.length > inlineVariants.length) return completeVariants;
    return inlineVariants;
  }

  function getSelectedOptionMap(productInfo, mode, enabled) {
    var selected = {};

    productInfo.querySelectorAll('variant-selects input[type="radio"]:checked').forEach(function(radio) {
      var optionName = optionNameFromInputName(radio.name);
      var value = radio.value;
      if (mode === 'personalize' && optionName.toLowerCase().indexOf('personalize') !== -1) {
        value = enabled ? 'Add custom text' : 'No custom text';
      }
      if (mode === 'style' && optionName.toLowerCase().indexOf('size') !== -1) {
        if (enabled && value.indexOf(STYLE_SUFFIX) === -1) value += STYLE_SUFFIX;
        if (!enabled && value.indexOf(STYLE_SUFFIX) !== -1) value = value.slice(0, -STYLE_SUFFIX.length);
      }
      selected[optionName] = value;
    });

    productInfo.querySelectorAll('variant-selects select').forEach(function(select) {
      var optionName = optionNameFromInputName(select.name);
      var value = select.value;
      if (mode === 'personalize' && optionName.toLowerCase().indexOf('personalize') !== -1) {
        value = enabled ? 'Add custom text' : 'No custom text';
      }
      if (mode === 'style' && optionName.toLowerCase().indexOf('size') !== -1) {
        if (enabled && value.indexOf(STYLE_SUFFIX) === -1) value += STYLE_SUFFIX;
        if (!enabled && value.indexOf(STYLE_SUFFIX) !== -1) value = value.slice(0, -STYLE_SUFFIX.length);
      }
      selected[optionName] = value;
    });

    return selected;
  }

  function findVariant(variants, optionMap) {
    for (var i = 0; i < variants.length; i += 1) {
      var matches = true;
      for (var j = 0; j < variants[i].options.length; j += 1) {
        var option = variants[i].options[j];
        if (optionMap[option.name] !== option.value) {
          matches = false;
          break;
        }
      }
      if (matches) return variants[i];
    }
    return null;
  }

  function formatMoney(cents, priceNode) {
    var currency = (priceNode && priceNode.getAttribute('data-kakavy-currency-code')) || 'USD';
    var locale = (priceNode && priceNode.getAttribute('data-kakavy-locale')) || undefined;
    var amount = Math.max(0, Number(cents || 0)) / 100;
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol'
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function setProductFormVariant(productInfo, variant) {
    if (!variant) return;
    var id = String(variant.id || '').split('/').pop();
    var sectionId = productInfo.dataset.section || productInfo.dataset.originalSection || '';
    var forms = [];
    if (sectionId) {
      var productForm = document.getElementById('product-form-' + sectionId);
      var installmentForm = document.getElementById('product-form-installment-' + sectionId);
      if (productForm) forms.push(productForm);
      if (installmentForm) forms.push(installmentForm);
    }
    if (!forms.length) {
      forms = Array.prototype.slice.call(productInfo.querySelectorAll('form[action*="/cart/add"]'));
    }
    forms.forEach(function(form) {
      var input = form.querySelector('input[name="id"]');
      if (!input || input.value === id) return;
      input.value = id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function updateMainPrice(productInfo, card, variant) {
    if (!variant) return;
    var priceNode = card.querySelector('[data-kakavy-personalize-price]');
    var priceRoot = productInfo.querySelector('[id^="price-"]') || productInfo.querySelector('.f-price');
    if (!priceRoot) return;
    var priceBox = priceRoot.classList && priceRoot.classList.contains('f-price') ? priceRoot : priceRoot.querySelector('.f-price');
    if (!priceBox) return;

    var price = Number(variant.price || 0);
    var compareAt = Number(variant.compareAtPrice || variant.compare_at_price || 0);
    var priceText = formatMoney(price, priceNode);
    var compareText = compareAt > price ? formatMoney(compareAt, priceNode) : '';
    var regularPrice = priceBox.querySelector('.f-price__regular .f-price-item--regular');
    var salePrice = priceBox.querySelector('.f-price__sale .f-price-item--sale');
    var comparePrice = priceBox.querySelector('.f-price__sale .f-price-item--regular s');

    priceBox.classList.toggle('f-price--on-sale', compareAt > price);
    if (compareAt > price && salePrice) {
      salePrice.textContent = priceText;
      if (comparePrice) comparePrice.textContent = compareText;
      return;
    }
    if (regularPrice) regularPrice.textContent = priceText;
    if (salePrice) salePrice.textContent = priceText;
    if (comparePrice) comparePrice.textContent = compareText;
  }

  function syncCard(card) {
    var productInfo = card.closest('product-info');
    if (!productInfo) return;
    var checkbox = card.querySelector('.kakavy-personalize__toggle');
    if (!checkbox) return;

    var mode = card.getAttribute('data-kakavy-mode') || 'personalize';
    var variants = getVariants(card, productInfo);
    var optionMap = getSelectedOptionMap(productInfo, mode, checkbox.checked);
    var variant = findVariant(variants, optionMap);
    if (!variant && !window.KAKAVY_CUSTOM_VARIANT_DATA) {
      loadVariantData(function() { syncCard(card); });
      return;
    }
    if (!variant) return;
    setProductFormVariant(productInfo, variant);
    updateMainPrice(productInfo, card, variant);
  }

  function scheduleSync(card) {
    syncCard(card);
    setTimeout(function() { syncCard(card); }, 80);
    setTimeout(function() { syncCard(card); }, 250);
    setTimeout(function() { syncCard(card); }, 700);
    loadVariantData(function() { syncCard(card); });
  }

  function bind(root) {
    root = root || document;
    root.querySelectorAll('[data-kakavy-personalize]').forEach(function(card) {
      if (card.dataset.globalSyncReady === 'true') {
        scheduleSync(card);
        return;
      }
      card.dataset.globalSyncReady = 'true';
      card.addEventListener('change', function() { scheduleSync(card); });
      var productInfo = card.closest('product-info');
      if (productInfo) {
        productInfo.addEventListener('change', function(event) {
          if (event.target.closest('variant-selects')) scheduleSync(card);
        });
      }
      scheduleSync(card);
    });
  }

  bind(document);
  document.addEventListener('DOMContentLoaded', function() { bind(document); });
  document.addEventListener('shopify:section:load', function(event) { bind(event.target); });
  document.addEventListener('variant:changed', function() { bind(document); });
})();


/* KAKAVY_PERSONALIZATION_REQUIRED_TEXT_V1_START */
(function() {
  if (window.KAKAVY_PERSONALIZATION_REQUIRED_TEXT_V1) return;
  window.KAKAVY_PERSONALIZATION_REQUIRED_TEXT_V1 = true;

  var ERROR_TEXT = 'Please enter custom text before adding to cart.';
  var CUSTOM_TEXT_PATTERN = /add custom text/i;

  function closestProductInfo(node) {
    if (!node || !node.closest) return document.querySelector('product-info');
    return node.closest('product-info') || document.querySelector('product-info');
  }

  function getCards(scope) {
    scope = scope || document;
    if (!scope.querySelectorAll) return [];
    return Array.prototype.slice.call(scope.querySelectorAll('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer'));
  }

  function getCardInput(card) {
    return card && card.querySelector('.kakavy-personalize__input, .kakavy-native-personalizer__input, input[name="properties[Custom text]"]');
  }

  function selectedOptionHasCustomText(productInfo) {
    if (!productInfo) return false;

    var selectedNodes = productInfo.querySelectorAll(
      'variant-selects input[type="radio"]:checked, variant-selects select'
    );

    for (var i = 0; i < selectedNodes.length; i += 1) {
      var node = selectedNodes[i];
      var value = node.tagName === 'SELECT' ? node.value : node.value;
      if (CUSTOM_TEXT_PATTERN.test(value || '')) return true;
    }

    return false;
  }

  function isCardActive(card) {
    if (!card) return false;
    var checkbox = card.querySelector('.kakavy-personalize__toggle, .kakavy-personalize__checkbox, .kakavy-native-personalizer__checkbox, input[type="checkbox"]');
    if (checkbox && checkbox.checked) return true;

    var input = getCardInput(card);
    if (input && input.required && !input.disabled) return true;

    return selectedOptionHasCustomText(closestProductInfo(card));
  }

  function getErrorNode(card) {
    var error = card.querySelector('.kakavy-personalize__error, .kakavy-native-personalizer__error');
    if (error) return error;

    error = document.createElement('p');
    error.className = 'kakavy-personalize__error';
    error.setAttribute('role', 'alert');
    error.style.cssText = 'display:none;margin:8px 0 0;color:#d92d20;font-size:12px;line-height:1.4;font-weight:700;';

    var hint = card.querySelector('.kakavy-personalize__hint, .kakavy-native-personalizer__help');
    if (hint && hint.parentNode) {
      hint.parentNode.insertBefore(error, hint);
    } else {
      card.appendChild(error);
    }

    return error;
  }

  function showError(card, input) {
    var error = getErrorNode(card);
    error.textContent = ERROR_TEXT;
    error.style.display = '';
    if (input) {
      input.setAttribute('aria-invalid', 'true');
      input.setCustomValidity(ERROR_TEXT);
      input.focus({ preventScroll: false });
      try {
        input.reportValidity();
      } catch (ignored) {
        // Older browsers can still rely on the visible inline error.
      }
    }
  }

  function clearError(card, input) {
    if (!card) return;
    var error = card.querySelector('.kakavy-personalize__error, .kakavy-native-personalizer__error');
    if (error) {
      error.textContent = '';
      error.style.display = 'none';
    }
    if (input) {
      input.removeAttribute('aria-invalid');
      input.setCustomValidity('');
    }
  }

  function validateCard(card) {
    if (!isCardActive(card)) {
      clearError(card, getCardInput(card));
      return true;
    }

    var input = getCardInput(card);
    if (!input) return true;

    if ((input.value || '').trim().length > 0) {
      clearError(card, input);
      return true;
    }

    showError(card, input);
    return false;
  }

  function validateScope(scope) {
    var cards = getCards(scope);
    for (var i = 0; i < cards.length; i += 1) {
      if (!validateCard(cards[i])) return false;
    }
    return true;
  }

  function formIsCartAdd(form) {
    if (!form) return false;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add/i.test(action) || Boolean(form.querySelector('[name="add"], input[name="id"]'));
  }

  function validateForm(form) {
    if (!formIsCartAdd(form)) return true;
    var productInfo = closestProductInfo(form);
    if (productInfo && getCards(productInfo).length > 0) return validateScope(productInfo);
    return validateScope(document);
  }

  function validateSubmitter(target) {
    var submitter = target && target.closest && target.closest(
      'button[type="submit"], input[type="submit"], button[name="add"], [name="add"], .shopify-payment-button__button'
    );
    if (!submitter) return true;

    var form = submitter.form || submitter.closest('form');
    var productInfo = closestProductInfo(submitter);
    if (!form && productInfo) form = productInfo.querySelector('form[action*="/cart/add"]');

    if (form) return validateForm(form);
    if (productInfo) return validateScope(productInfo);
    return true;
  }

  document.addEventListener('input', function(event) {
    var input = event.target;
    if (!input || !input.closest) return;
    var card = input.closest('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer');
    if (!card || input !== getCardInput(card)) return;
    if ((input.value || '').trim().length > 0) clearError(card, input);
  }, true);

  document.addEventListener('change', function(event) {
    var card = event.target && event.target.closest && event.target.closest('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer');
    if (card) validateCard(card);
  }, true);

  document.addEventListener('click', function(event) {
    if (validateSubmitter(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('submit', function(event) {
    if (validateForm(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();
/* KAKAVY_PERSONALIZATION_REQUIRED_TEXT_V1_END */


/* KAKAVY_PERSONALIZATION_ORDER_PROPERTIES_V1_START */
(function() {
  if (window.KAKAVY_PERSONALIZATION_ORDER_PROPERTIES_V1) return;
  window.KAKAVY_PERSONALIZATION_ORDER_PROPERTIES_V1 = true;

  var PROPERTY_NAME = 'properties[Custom text]';
  var PROPERTY_LABEL = 'Custom text';
  var CUSTOM_TEXT_PATTERN = /add custom text/i;
  var MAX_LENGTH = 10;

  function cleanPersonalizeValue(value) {
    var text = String(value || '').replace(/[^A-Za-z0-9 ]/g, '');
    var counts = {};
    var result = '';

    for (var i = 0; i < text.length; i += 1) {
      var character = text.charAt(i);

      if (character !== ' ') {
        var key = character.toLowerCase();
        var nextCount = (counts[key] || 0) + 1;

        if (nextCount > 2) continue;
        counts[key] = nextCount;
      }

      result += character;
      if (result.length >= MAX_LENGTH) break;
    }

    // Preserve a trailing space while the customer is still typing. The
    // add-on/checkout pipeline trims the finished value before cart creation.
    return result;
  }

  function closestProductInfo(node) {
    if (!node) return document.querySelector('product-info');
    if (node.matches && node.matches('product-info')) return node;
    if (node.closest) return node.closest('product-info') || document.querySelector('product-info');
    return document.querySelector('product-info');
  }

  function getProductInfoSectionId(productInfo) {
    if (!productInfo || !productInfo.dataset) return '';
    return productInfo.dataset.section || productInfo.dataset.sectionId || '';
  }

  function uniquePush(list, item) {
    if (!item) return;
    for (var i = 0; i < list.length; i += 1) {
      if (list[i] === item) return;
    }
    list.push(item);
  }

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = String(form.getAttribute('action') || '');
    return /\/cart\/add/i.test(action) || !!form.querySelector('input[name="id"]');
  }

  function getCartForms(productInfo, submitter) {
    var forms = [];
    var sectionId = getProductInfoSectionId(productInfo);

    if (submitter && submitter.form && isCartAddForm(submitter.form)) {
      uniquePush(forms, submitter.form);
    }

    if (sectionId) {
      uniquePush(forms, document.getElementById('product-form-' + sectionId));
      uniquePush(forms, document.getElementById('product-form-installment-' + sectionId));
    }

    if (productInfo && productInfo.querySelectorAll) {
      productInfo.querySelectorAll('form[action*="/cart/add"], form').forEach(function(form) {
        if (isCartAddForm(form)) uniquePush(forms, form);
      });
    }

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
      if (productInfo && form.closest && form.closest('product-info') && form.closest('product-info') !== productInfo) return;
      if (isCartAddForm(form)) uniquePush(forms, form);
    });

    return forms;
  }

  function selectedOptionHasCustomText(productInfo) {
    if (!productInfo || !productInfo.querySelectorAll) return false;
    var optionNodes = productInfo.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select, input[name^="options["], select[name^="options["]');

    for (var i = 0; i < optionNodes.length; i += 1) {
      var node = optionNodes[i];
      if (node.type === 'radio' && !node.checked) continue;
      if (CUSTOM_TEXT_PATTERN.test(String(node.value || ''))) return true;

      if (node.tagName === 'SELECT' && node.selectedIndex >= 0) {
        var selectedText = node.options[node.selectedIndex] ? node.options[node.selectedIndex].text : '';
        if (CUSTOM_TEXT_PATTERN.test(selectedText)) return true;
      }
    }

    return false;
  }

  function getPersonalizeCards(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    return Array.prototype.slice.call(root.querySelectorAll('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer'));
  }

  function getCardInput(card) {
    if (!card || !card.querySelector) return null;
    return card.querySelector('.kakavy-personalize__input, .kakavy-native-personalizer__input, input[name="properties[Custom text]"]');
  }

  function isCardActive(card) {
    if (!card) return false;
    var checkbox = card.querySelector && card.querySelector('.kakavy-personalize__checkbox, .kakavy-native-personalizer__checkbox, input[type="checkbox"]');
    if (checkbox && checkbox.checked) return true;
    return selectedOptionHasCustomText(closestProductInfo(card));
  }

  function getActivePersonalizationState(scope) {
    var productInfo = closestProductInfo(scope);
    var cards = getPersonalizeCards(productInfo || document);
    if (productInfo && cards.length === 0) {
      cards = getPersonalizeCards(document);
    }
    var fallbackCard = null;

    for (var i = 0; i < cards.length; i += 1) {
      if (!fallbackCard) fallbackCard = cards[i];
      if (isCardActive(cards[i])) {
        var activeInput = getCardInput(cards[i]);
        return {
          active: true,
          card: cards[i],
          input: activeInput,
          text: cleanPersonalizeValue(activeInput ? activeInput.value : ''),
          productInfo: closestProductInfo(cards[i])
        };
      }
    }

    if (selectedOptionHasCustomText(productInfo) && fallbackCard) {
      var fallbackInput = getCardInput(fallbackCard);
      return {
        active: true,
        card: fallbackCard,
        input: fallbackInput,
        text: cleanPersonalizeValue(fallbackInput ? fallbackInput.value : ''),
        productInfo: productInfo
      };
    }

    return {
      active: false,
      card: null,
      input: null,
      text: '',
      productInfo: productInfo
    };
  }

  function getCurrentVariantId(productInfo, submitter) {
    var forms = getCartForms(productInfo, submitter);

    for (var i = 0; i < forms.length; i += 1) {
      var idInput = forms[i].querySelector('input[name="id"], select[name="id"]');
      if (idInput && idInput.value) return String(idInput.value);
    }

    return '';
  }

  function ensureHiddenProperty(form) {
    var input = form.querySelector('input[data-kakavy-custom-text-property][name="properties[Custom text]"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = PROPERTY_NAME;
      input.setAttribute('data-kakavy-custom-text-property', 'true');
      form.appendChild(input);
    }

    return input;
  }

  function disableManagedProperties(form) {
    form.querySelectorAll('input[data-kakavy-custom-text-property][name="properties[Custom text]"]').forEach(function(input) {
      input.remove();
    });
  }

  function applyPropertyToForms(scope, submitter) {
    var state = getActivePersonalizationState(scope);
    var productInfo = state.productInfo || closestProductInfo(scope);
    var forms = getCartForms(productInfo, submitter);

    for (var i = 0; i < forms.length; i += 1) {
      disableManagedProperties(forms[i]);
    }

    if (!state.active || !state.text) return state;

    if (state.input && state.input.value !== state.text) {
      state.input.value = state.text;
    }

    for (var formIndex = 0; formIndex < forms.length; formIndex += 1) {
      var form = forms[formIndex];
      var visibleInputInForm = state.input && form.contains(state.input) && state.input.name === PROPERTY_NAME;

      if (visibleInputInForm) {
        state.input.disabled = false;
        state.input.value = state.text;
      } else {
        var hiddenInput = ensureHiddenProperty(form);
        hiddenInput.value = state.text;
        hiddenInput.disabled = false;
      }
    }

    return state;
  }

  function bodyVariantMatches(body, activeVariantId) {
    if (!activeVariantId || !body || !body.get) return true;
    var bodyVariantId = body.get('id');
    return !bodyVariantId || String(bodyVariantId) === String(activeVariantId);
  }

  function addPropertyToRequestBody(body, state, activeVariantId) {
    if (!state || !state.active || !state.text || !body) return body;

    if (window.FormData && body instanceof FormData) {
      if (!bodyVariantMatches(body, activeVariantId)) return body;
      body.set(PROPERTY_NAME, state.text);
      return body;
    }

    if (window.URLSearchParams && body instanceof URLSearchParams) {
      if (!bodyVariantMatches(body, activeVariantId)) return body;
      body.set(PROPERTY_NAME, state.text);
      return body;
    }

    if (typeof body === 'string') {
      try {
        if (body.charAt(0) === '{') {
          var data = JSON.parse(body);

          if (Array.isArray(data.items)) {
            data.items = data.items.map(function(item) {
              if (activeVariantId && item.id && String(item.id) !== String(activeVariantId)) return item;
              item.properties = item.properties || {};
              item.properties[PROPERTY_LABEL] = state.text;
              return item;
            });
          } else if (!activeVariantId || !data.id || String(data.id) === String(activeVariantId)) {
            data.properties = data.properties || {};
            data.properties[PROPERTY_LABEL] = state.text;
          }

          return JSON.stringify(data);
        }

        var params = new URLSearchParams(body);
        if (!bodyVariantMatches(params, activeVariantId)) return body;
        params.set(PROPERTY_NAME, state.text);
        return params.toString();
      } catch (error) {
        return body;
      }
    }

    return body;
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?/i.test(String(url || ''));
  }

  function installFetchPatch() {
    if (!window.fetch || window.KAKAVY_PERSONALIZATION_ORDER_PROPERTIES_FETCH_V1) return;
    window.KAKAVY_PERSONALIZATION_ORDER_PROPERTIES_FETCH_V1 = true;
    var originalFetch = window.fetch;

    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var nextInit = init;

      if (isCartAddUrl(url)) {
        var state = applyPropertyToForms(document, null);
        var activeVariantId = getCurrentVariantId(state.productInfo, null);

        if (init && init.body) {
          nextInit = Object.assign({}, init, {
            body: addPropertyToRequestBody(init.body, state, activeVariantId)
          });
        }
      }

      return originalFetch.call(this, input, nextInit);
    };
  }

  document.addEventListener('input', function(event) {
    if (event.target && event.target.matches && event.target.matches('.kakavy-personalize__input, .kakavy-native-personalizer__input, input[name="properties[Custom text]"]')) {
      var cleaned = cleanPersonalizeValue(event.target.value);
      if (event.target.value !== cleaned) event.target.value = cleaned;
      applyPropertyToForms(event.target, null);
    }
  }, true);

  document.addEventListener('change', function(event) {
    if (event.target && event.target.closest && (event.target.closest('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer') || event.target.closest('variant-selects'))) {
      applyPropertyToForms(event.target, null);
    }
  }, true);

  document.addEventListener('click', function(event) {
    var submitter = event.target && event.target.closest && event.target.closest('button[type="submit"], input[type="submit"], button[name="add"], .shopify-payment-button__button');
    if (submitter) applyPropertyToForms(submitter, submitter);
  }, true);

  document.addEventListener('submit', function(event) {
    if (isCartAddForm(event.target)) {
      applyPropertyToForms(event.target, event.submitter || null);
    }
  }, true);

  document.addEventListener('variant:changed', function(event) {
    applyPropertyToForms(event.target || document, null);
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    applyPropertyToForms(document, null);
    installFetchPatch();
  });

  document.addEventListener('shopify:section:load', function(event) {
    applyPropertyToForms(event.target || document, null);
  });

  applyPropertyToForms(document, null);
  installFetchPatch();
})();
/* KAKAVY_PERSONALIZATION_ORDER_PROPERTIES_V1_END */

/* KAKAVY_PERSONALIZATION_DYNAMIC_CHECKOUT_REQUIRED_V1_START */
(function() {
  if (window.KAKAVY_PERSONALIZATION_DYNAMIC_CHECKOUT_REQUIRED_V1) return;
  window.KAKAVY_PERSONALIZATION_DYNAMIC_CHECKOUT_REQUIRED_V1 = true;

  var ERROR_TEXT = 'Please enter custom text before checking out.';
  var CUSTOM_TEXT_PATTERN = /add custom text/i;
  var DYNAMIC_CHECKOUT_SELECTOR = [
    '.shopify-payment-button__button',
    '.shopify-payment-button__more-options',
    '.shopify-payment-button [role="button"]',
    '.shopify-payment-button a',
    'shopify-accelerated-checkout',
    'shopify-buy-it-now-button',
    'shop-pay-wallet-button'
  ].join(',');

  var CHECKOUT_TRIGGER_SELECTOR = [
    DYNAMIC_CHECKOUT_SELECTOR,
    'button[type="submit"]',
    'input[type="submit"]',
    'button[name="add"]',
    '[name="add"]'
  ].join(',');

  function closestProductInfo(node) {
    if (!node) return document.querySelector('product-info');
    if (node.matches && node.matches('product-info')) return node;
    if (node.closest) return node.closest('product-info') || document.querySelector('product-info');
    return document.querySelector('product-info');
  }

  function getCards(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    return Array.prototype.slice.call(root.querySelectorAll('[data-kakavy-personalize], .kakavy-personalize'));
  }

  function getCardInput(card) {
    if (!card || !card.querySelector) return null;
    return card.querySelector('.kakavy-personalize__input, input[name="properties[Custom text]"]');
  }

  function selectedOptionHasCustomText(productInfo) {
    if (!productInfo || !productInfo.querySelectorAll) return false;
    var nodes = productInfo.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select, input[name^="options["], select[name^="options["]');

    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (node.type === 'radio' && !node.checked) continue;
      if (CUSTOM_TEXT_PATTERN.test(String(node.value || ''))) return true;

      if (node.tagName === 'SELECT' && node.selectedIndex >= 0) {
        var option = node.options[node.selectedIndex];
        if (CUSTOM_TEXT_PATTERN.test(String(option ? option.text : ''))) return true;
      }
    }

    return false;
  }

  function isCardActive(card) {
    if (!card) return false;
    var checkbox = card.querySelector('.kakavy-personalize__toggle, input[type="checkbox"]');
    if (checkbox && checkbox.checked) return true;
    return selectedOptionHasCustomText(closestProductInfo(card));
  }

  function getErrorNode(card) {
    var error = card && card.querySelector && card.querySelector('.kakavy-personalize__error');
    if (error) return error;

    if (!card) return null;
    error = document.createElement('p');
    error.className = 'kakavy-personalize__error';
    error.setAttribute('role', 'alert');
    error.style.cssText = 'display:none;margin:8px 0 0;color:#d92d20;font-size:12px;line-height:1.4;font-weight:700;';

    var hint = card.querySelector('.kakavy-personalize__hint');
    if (hint && hint.parentNode) {
      hint.parentNode.insertBefore(error, hint);
    } else {
      card.appendChild(error);
    }

    return error;
  }

  function showError(card, input) {
    var error = getErrorNode(card);
    if (error) {
      error.textContent = ERROR_TEXT;
      error.style.display = '';
    }

    if (input) {
      input.setAttribute('aria-invalid', 'true');
      input.setCustomValidity(ERROR_TEXT);
      input.focus({ preventScroll: false });
      try {
        input.reportValidity();
      } catch (ignored) {}
    }
  }

  function clearError(card, input) {
    if (!card) return;
    var error = card.querySelector('.kakavy-personalize__error');
    if (error) {
      error.textContent = '';
      error.style.display = 'none';
    }
    if (input) {
      input.removeAttribute('aria-invalid');
      input.setCustomValidity('');
    }
  }

  function findInvalidCustomCard(scope) {
    var productInfo = closestProductInfo(scope);
    var cards = getCards(productInfo || document);

    for (var i = 0; i < cards.length; i += 1) {
      var card = cards[i];
      if (!isCardActive(card)) {
        clearError(card, getCardInput(card));
        continue;
      }

      var input = getCardInput(card);
      if (!input) continue;

      if ((input.value || '').trim().length === 0) {
        return { card: card, input: input, productInfo: closestProductInfo(card) };
      }

      clearError(card, input);
    }

    return null;
  }

  function getDynamicButtons(productInfo) {
    var root = productInfo && productInfo.querySelectorAll ? productInfo : document;
    return Array.prototype.slice.call(root.querySelectorAll(DYNAMIC_CHECKOUT_SELECTOR));
  }

  function storeOriginalState(node) {
    if (!node.hasAttribute('data-kakavy-dynamic-required-original')) {
      node.setAttribute('data-kakavy-dynamic-required-original', 'true');
      node.setAttribute('data-kakavy-original-disabled', node.disabled ? 'true' : 'false');
      node.setAttribute('data-kakavy-original-tabindex', node.getAttribute('tabindex') || '');
      node.setAttribute('data-kakavy-original-pointer-events', node.style.pointerEvents || '');
      node.setAttribute('data-kakavy-original-opacity', node.style.opacity || '');
    }
  }

  function disableNode(node) {
    storeOriginalState(node);
    node.setAttribute('data-kakavy-dynamic-required-disabled', 'true');
    node.setAttribute('aria-disabled', 'true');
    node.setAttribute('tabindex', '-1');
    node.style.pointerEvents = 'none';
    node.style.opacity = '0.55';
    if ('disabled' in node) node.disabled = true;
  }

  function enableNode(node) {
    if (!node.hasAttribute('data-kakavy-dynamic-required-original')) return;

    node.removeAttribute('data-kakavy-dynamic-required-disabled');
    node.removeAttribute('aria-disabled');

    var originalDisabled = node.getAttribute('data-kakavy-original-disabled') === 'true';
    if ('disabled' in node && !originalDisabled) node.disabled = false;

    var originalTabIndex = node.getAttribute('data-kakavy-original-tabindex');
    if (originalTabIndex) {
      node.setAttribute('tabindex', originalTabIndex);
    } else {
      node.removeAttribute('tabindex');
    }

    node.style.pointerEvents = node.getAttribute('data-kakavy-original-pointer-events') || '';
    node.style.opacity = node.getAttribute('data-kakavy-original-opacity') || '';
  }

  function refreshDynamicCheckoutState(scope) {
    var productInfo = closestProductInfo(scope);
    var invalid = findInvalidCustomCard(productInfo || scope);
    var buttons = getDynamicButtons(productInfo || document);

    for (var i = 0; i < buttons.length; i += 1) {
      if (invalid) {
        disableNode(buttons[i]);
      } else {
        enableNode(buttons[i]);
      }
    }
  }

  function blockIfInvalid(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest(CHECKOUT_TRIGGER_SELECTOR);
    if (!trigger) return;

    var invalid = findInvalidCustomCard(trigger);
    if (!invalid) return;

    showError(invalid.card, invalid.input);
    refreshDynamicCheckoutState(invalid.productInfo || trigger);
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function(eventName) {
    document.addEventListener(eventName, blockIfInvalid, true);
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    blockIfInvalid(event);
  }, true);

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.querySelector || !form.querySelector('input[name="id"], select[name="id"]')) return;

    var invalid = findInvalidCustomCard(form);
    if (!invalid) return;

    showError(invalid.card, invalid.input);
    refreshDynamicCheckoutState(invalid.productInfo || form);
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('input', function(event) {
    if (event.target && event.target.matches && event.target.matches('.kakavy-personalize__input, input[name="properties[Custom text]"]')) {
      refreshDynamicCheckoutState(event.target);
    }
  }, true);

  document.addEventListener('change', function(event) {
    if (event.target && event.target.closest && (event.target.closest('[data-kakavy-personalize], .kakavy-personalize') || event.target.closest('variant-selects'))) {
      refreshDynamicCheckoutState(event.target);
    }
  }, true);

  document.addEventListener('variant:changed', function(event) {
    refreshDynamicCheckoutState(event.target || document);
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    refreshDynamicCheckoutState(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    refreshDynamicCheckoutState(event.target || document);
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function() {
      refreshDynamicCheckoutState(document);
    });

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    }
  }

  refreshDynamicCheckoutState(document);
})();
/* KAKAVY_PERSONALIZATION_DYNAMIC_CHECKOUT_REQUIRED_V1_END */


/* KAKAVY_PERSONALIZATION_INPUT_LIMITS_V1_START */
(function() {
  if (window.KAKAVY_PERSONALIZATION_INPUT_LIMITS_V1) return;
  window.KAKAVY_PERSONALIZATION_INPUT_LIMITS_V1 = true;

  var MAX_LENGTH = 10;
  var HINT_TEXT = 'Maximum 10 letters, numbers, or spaces. Each letter or number may appear up to twice.';
  var TITLE_TEXT = 'Use letters, numbers, and spaces only. Each letter or number can appear up to twice.';

  function isPersonalizeInput(node) {
    if (!node || node.tagName !== 'INPUT') return false;
    if (node.classList && node.classList.contains('kakavy-personalize__input')) return true;
    if (node.classList && node.classList.contains('kakavy-native-personalizer__input')) return true;

    var name = (node.getAttribute('name') || '').toLowerCase();
    if (name.indexOf('properties[') !== -1 && name.indexOf('custom text') !== -1) return true;

    return Boolean(node.closest && node.closest('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer'));
  }

  function cleanPersonalizeValue(value) {
    var text = String(value || '').replace(/[^A-Za-z0-9 ]/g, '');
    var counts = {};
    var result = '';

    for (var i = 0; i < text.length; i += 1) {
      var character = text.charAt(i);

      if (character !== ' ') {
        var key = character.toLowerCase();
        var nextCount = (counts[key] || 0) + 1;
        if (nextCount > 2) continue;
        counts[key] = nextCount;
      }

      result += character;
      if (result.length >= MAX_LENGTH) break;
    }

    return result;
  }

  function setCaret(input, position) {
    try {
      input.setSelectionRange(position, position);
    } catch (error) {
      // Some mobile inputs do not expose selection APIs reliably.
    }
  }

  function updatePersonalizeMeta(input) {
    var card = input.closest && input.closest('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer');
    if (!card) return;

    var count = card.querySelector('[data-kakavy-count], .kakavy-native-personalizer__count');
    if (count) {
      var length = String((input.value || '').length);
      count.textContent = count.classList && count.classList.contains('kakavy-native-personalizer__count') ? length + '/' + MAX_LENGTH : length;
    }

    var hint = card.querySelector('.kakavy-personalize__hint, .kakavy-native-personalizer__help');
    if (hint) hint.textContent = HINT_TEXT;
  }

  function normalizePersonalizeInput(input) {
    if (!isPersonalizeInput(input)) return;

    input.setAttribute('maxlength', String(MAX_LENGTH));
    input.setAttribute('pattern', '[A-Za-z0-9 ]*');
    input.setAttribute('title', TITLE_TEXT);
    input.setAttribute('autocomplete', 'off');

    var original = input.value || '';
    var cleaned = cleanPersonalizeValue(original);

    if (original !== cleaned) {
      var originalLength = original.length;
      var originalSelection = typeof input.selectionStart === 'number' ? input.selectionStart : cleaned.length;
      input.value = cleaned;
      setCaret(input, Math.max(0, Math.min(cleaned.length, originalSelection - (originalLength - cleaned.length))));
    }

    updatePersonalizeMeta(input);
  }

  function insertCleanText(input, text) {
    var start = typeof input.selectionStart === 'number' ? input.selectionStart : input.value.length;
    var end = typeof input.selectionEnd === 'number' ? input.selectionEnd : start;
    input.value = cleanPersonalizeValue(input.value.slice(0, start) + text + input.value.slice(end));
    setCaret(input, input.value.length);
    updatePersonalizeMeta(input);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function bindPersonalizeInputs(root) {
    root = root || document;
    if (!root.querySelectorAll) return;

    root.querySelectorAll('.kakavy-personalize__input, .kakavy-native-personalizer__input, input[name="properties[Custom text]"]').forEach(function(input) {
      normalizePersonalizeInput(input);
    });

    root.querySelectorAll('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer').forEach(function(card) {
      var hint = card.querySelector('.kakavy-personalize__hint, .kakavy-native-personalizer__help');
      if (hint) hint.textContent = HINT_TEXT;
    });
  }

  document.addEventListener('beforeinput', function(event) {
    var input = event.target;
    if (!isPersonalizeInput(input) || event.defaultPrevented || event.isComposing) return;
    if (event.inputType && event.inputType.indexOf('delete') === 0) return;
    if (typeof event.data !== 'string' || !event.data) return;

    var start = typeof input.selectionStart === 'number' ? input.selectionStart : input.value.length;
    var end = typeof input.selectionEnd === 'number' ? input.selectionEnd : start;
    var proposed = input.value.slice(0, start) + event.data + input.value.slice(end);
    var cleaned = cleanPersonalizeValue(proposed);

    if (proposed !== cleaned) {
      event.preventDefault();
      input.value = cleaned;
      setCaret(input, cleaned.length);
      updatePersonalizeMeta(input);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }, true);

  document.addEventListener('paste', function(event) {
    var input = event.target;
    if (!isPersonalizeInput(input)) return;

    var clipboard = event.clipboardData || window.clipboardData;
    if (!clipboard) return;

    event.preventDefault();
    insertCleanText(input, clipboard.getData('text') || '');
  }, true);

  document.addEventListener('input', function(event) {
    normalizePersonalizeInput(event.target);
  }, true);

  document.addEventListener('change', function(event) {
    normalizePersonalizeInput(event.target);
  }, true);

  document.addEventListener('submit', function() {
    bindPersonalizeInputs(document);
  }, true);

  document.addEventListener('focusin', function(event) {
    normalizePersonalizeInput(event.target);
  }, true);

  bindPersonalizeInputs(document);
  document.addEventListener('DOMContentLoaded', function() { bindPersonalizeInputs(document); });
  document.addEventListener('shopify:section:load', function(event) { bindPersonalizeInputs(event.target); });
})();
/* KAKAVY_PERSONALIZATION_INPUT_LIMITS_V1_END */


/* KAKAVY_PERSONALIZATION_NO_CUSTOM_CLEANUP_V1_START */
(function() {
  if (window.KAKAVY_PERSONALIZATION_NO_CUSTOM_CLEANUP_V1) return;
  window.KAKAVY_PERSONALIZATION_NO_CUSTOM_CLEANUP_V1 = true;

  var PROPERTY_NAME = 'properties[Custom text]';
  var PROPERTY_LABEL = 'Custom text';
  var NO_CUSTOM_PATTERN = /^\s*(no custom text|no customization|none)\s*$/i;
  var ADD_CUSTOM_PATTERN = /add custom text/i;

  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?/i.test(String(url || ''));
  }

  function isNoCustomValue(value) {
    return NO_CUSTOM_PATTERN.test(String(value || ''));
  }

  function cleanPropertyInputs(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('input[name="properties[Custom text]"], textarea[name="properties[Custom text]"], select[name="properties[Custom text]"]').forEach(function(input) {
      var value = String(input.value || '').trim();
      var needsCustom = inputNeedsCustomText(input);
      if (needsCustom) input.disabled = false;
      if (!needsCustom || !value || isNoCustomValue(value)) {
        input.value = '';
        if (!needsCustom) input.disabled = true;
        return;
      }
      input.disabled = false;
    });
  }

  function selectedOptionNeedsCustomText(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select, input[name^="options["], select[name^="options["]');

    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (node.type === 'radio' && !node.checked) continue;
      if (ADD_CUSTOM_PATTERN.test(String(node.value || ''))) return true;

      if (node.tagName === 'SELECT' && node.selectedIndex >= 0) {
        var option = node.options[node.selectedIndex];
        if (ADD_CUSTOM_PATTERN.test(String(option ? option.text : ''))) return true;
      }
    }

    return false;
  }

  function closestProductInfo(node) {
    if (!node) return document.querySelector('product-info');
    if (node.matches && node.matches('product-info')) return node;
    if (node.closest) return node.closest('product-info') || document.querySelector('product-info');
    return document.querySelector('product-info');
  }

  function isCardChecked(card) {
    if (!card || !card.querySelector) return false;
    var checkbox = card.querySelector('.kakavy-personalize__toggle, .kakavy-personalize__checkbox, .kakavy-native-personalizer__checkbox, input[type="checkbox"]');
    return Boolean(checkbox && checkbox.checked);
  }

  function scopeNeedsCustomText(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (selectedOptionNeedsCustomText(root)) return true;

    var cards = root.querySelectorAll('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer');
    for (var i = 0; i < cards.length; i += 1) {
      if (isCardChecked(cards[i])) return true;
    }

    var productInfo = closestProductInfo(root);
    if (productInfo && productInfo !== root) return scopeNeedsCustomText(productInfo);
    return false;
  }

  function inputNeedsCustomText(input) {
    if (!input) return false;
    var card = input.closest && input.closest('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer');
    if (card) return isCardChecked(card) || selectedOptionNeedsCustomText(closestProductInfo(card));
    return scopeNeedsCustomText(closestProductInfo(input) || input.form || document);
  }

  function removeNoCustomFromForm(form) {
    if (!form || !form.querySelectorAll) return;
    var needsCustom = scopeNeedsCustomText(form.closest && form.closest('product-info') || form);

    form.querySelectorAll('input[name="properties[Custom text]"], textarea[name="properties[Custom text]"], select[name="properties[Custom text]"]').forEach(function(input) {
      var value = String(input.value || '').trim();
      if (needsCustom) input.disabled = false;
      if (!needsCustom || !value || isNoCustomValue(value)) {
        input.value = '';
        input.disabled = true;
        return;
      }
      input.disabled = false;
    });
  }

  function cleanFormData(body) {
    var value = body.get(PROPERTY_NAME);
    if (!value || isNoCustomValue(value)) body.delete(PROPERTY_NAME);
    return body;
  }

  function cleanUrlSearchParams(body) {
    var value = body.get(PROPERTY_NAME);
    if (!value || isNoCustomValue(value)) body.delete(PROPERTY_NAME);
    return body;
  }

  function cleanJsonBody(body) {
    if (Array.isArray(body.items)) {
      body.items.forEach(function(item) {
        if (!item || !item.properties) return;
        var value = item.properties[PROPERTY_LABEL];
        if (!value || isNoCustomValue(value)) delete item.properties[PROPERTY_LABEL];
      });
      return body;
    }

    if (body && body.properties) {
      var value = body.properties[PROPERTY_LABEL];
      if (!value || isNoCustomValue(value)) delete body.properties[PROPERTY_LABEL];
    }

    return body;
  }

  function cleanRequestBody(body) {
    if (!body) return body;

    if (window.FormData && body instanceof FormData) return cleanFormData(body);
    if (window.URLSearchParams && body instanceof URLSearchParams) return cleanUrlSearchParams(body);

    if (typeof body === 'string') {
      try {
        if (body.charAt(0) === '{') {
          return JSON.stringify(cleanJsonBody(JSON.parse(body)));
        }

        var params = new URLSearchParams(body);
        cleanUrlSearchParams(params);
        return params.toString();
      } catch (error) {
        return body;
      }
    }

    return body;
  }

  if (window.fetch && !window.KAKAVY_PERSONALIZATION_NO_CUSTOM_FETCH_CLEANUP_V1) {
    window.KAKAVY_PERSONALIZATION_NO_CUSTOM_FETCH_CLEANUP_V1 = true;
    var originalFetch = window.fetch;

    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (isCartAddUrl(url) && init && init.body) {
        init = Object.assign({}, init, { body: cleanRequestBody(init.body) });
      }
      return originalFetch.call(this, input, init);
    };
  }

  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype && !window.KAKAVY_PERSONALIZATION_NO_CUSTOM_XHR_CLEANUP_V1) {
    window.KAKAVY_PERSONALIZATION_NO_CUSTOM_XHR_CLEANUP_V1 = true;
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function(method, url) {
      this.__kakavyNoCustomCartAddUrl = isCartAddUrl(url);
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function(body) {
      if (this.__kakavyNoCustomCartAddUrl) {
        body = cleanRequestBody(body);
      }
      return originalSend.call(this, body);
    };
  }

  ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function(eventName) {
    document.addEventListener(eventName, function(event) {
      var trigger = event.target && event.target.closest && event.target.closest('button[type="submit"], input[type="submit"], button[name="add"], [name="add"], .shopify-payment-button__button, .shopify-payment-button__more-options, shopify-accelerated-checkout, shop-pay-wallet-button');
      if (!trigger) return;
      var form = trigger.form || trigger.closest && trigger.closest('form');
      if (form) removeNoCustomFromForm(form);
      cleanPropertyInputs(document);
    }, true);
  });

  document.addEventListener('submit', function(event) {
    removeNoCustomFromForm(event.target);
  }, true);

  document.addEventListener('change', function(event) {
    if (event.target && event.target.closest && (event.target.closest('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer') || event.target.closest('variant-selects'))) {
      cleanPropertyInputs(document);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    cleanPropertyInputs(document);
  });

  cleanPropertyInputs(document);
})();
/* KAKAVY_PERSONALIZATION_NO_CUSTOM_CLEANUP_V1_END */

/* KAKAVY_PERSONALIZATION_ADDON_PRODUCT_MODE_V1_START */
(function() {
  if (window.KAKAVY_PERSONALIZATION_ADDON_PRODUCT_MODE_V1) return;
  window.KAKAVY_PERSONALIZATION_ADDON_PRODUCT_MODE_V1 = true;

  var ADDON_VARIANT_ID = '49915109605618';
  var PROPERTY_NAME = 'Custom text';
  var PROPERTY_FIELD = 'properties[Custom text]';
  var ADD_CUSTOM_PATTERN = /add custom text/i;
  var MAX_LENGTH = 10;
  var pendingSubmitState = null;

  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?/i.test(String(url || ''));
  }

  function cleanCustomText(value) {
    var text = String(value || '').replace(/[^A-Za-z0-9 ]/g, '');
    var counts = {};
    var result = '';

    for (var i = 0; i < text.length; i += 1) {
      var character = text.charAt(i);
      if (character !== ' ') {
        var key = character.toLowerCase();
        var nextCount = (counts[key] || 0) + 1;
        if (nextCount > 2) continue;
        counts[key] = nextCount;
      }
      result += character;
      if (result.length >= MAX_LENGTH) break;
    }

    return result.trim();
  }

  function closestProductInfo(node) {
    if (!node) return document.querySelector('product-info');
    if (node.matches && node.matches('product-info')) return node;
    if (node.closest) return node.closest('product-info') || document.querySelector('product-info');
    return document.querySelector('product-info');
  }

  function getCardInput(card) {
    if (!card || !card.querySelector) return null;
    return card.querySelector('.kakavy-personalize__input, .kakavy-native-personalizer__input, input[name="properties[Custom text]"]');
  }

  function selectedOptionHasCustomText(productInfo) {
    if (!productInfo || !productInfo.querySelectorAll) return false;
    var nodes = productInfo.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select, input[name^="options["], select[name^="options["]');

    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (node.type === 'radio' && !node.checked) continue;
      if (ADD_CUSTOM_PATTERN.test(String(node.value || ''))) return true;
      if (node.tagName === 'SELECT' && node.selectedIndex >= 0) {
        var option = node.options[node.selectedIndex];
        if (ADD_CUSTOM_PATTERN.test(String(option ? option.text : ''))) return true;
      }
    }
    return false;
  }

  function isCardActive(card) {
    if (!card) return false;
    var checkbox = card.querySelector && card.querySelector('.kakavy-personalize__toggle, .kakavy-personalize__checkbox, .kakavy-native-personalizer__checkbox, input[type="checkbox"]');
    if (checkbox && checkbox.checked) return true;
    return selectedOptionHasCustomText(closestProductInfo(card));
  }

  function getActiveState(scope) {
    var productInfo = closestProductInfo(scope);
    var cards = Array.prototype.slice.call((productInfo || document).querySelectorAll('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer'));
    if (productInfo && cards.length === 0) {
      cards = Array.prototype.slice.call(document.querySelectorAll('[data-kakavy-personalize], .kakavy-personalize, .kakavy-native-personalizer'));
    }

    for (var i = 0; i < cards.length; i += 1) {
      var card = cards[i];
      if (!isCardActive(card)) continue;
      var input = getCardInput(card);
      var text = cleanCustomText(input ? input.value : '');
      return { active: true, card: card, input: input, text: text, productInfo: closestProductInfo(card) || productInfo };
    }

    return { active: false, card: null, input: null, text: '', productInfo: productInfo };
  }

  function getQuantityFromBody(body) {
    var value = body && body.get && body.get('quantity');
    var qty = Number(value || 1);
    return Number.isFinite(qty) && qty > 0 ? Math.floor(qty) : 1;
  }

  function getAddForm(scope) {
    if (!scope) return null;
    if (scope.matches && scope.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) return scope;
    if (scope.closest) {
      var closest = scope.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
      if (closest) return closest;
    }
    var productInfo = closestProductInfo(scope);
    return productInfo && productInfo.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
  }

  function getFormVariantId(form) {
    if (!form) return '';
    try {
      return String(new FormData(form).get('id') || '');
    } catch (error) {
      var input = form.querySelector && form.querySelector('[name="id"]');
      return String(input ? input.value : '');
    }
  }

  function idsFromObject(data) {
    if (!data) return [];
    if (Array.isArray(data.items)) {
      return data.items.map(function(item) { return String(item && item.id || ''); }).filter(Boolean);
    }
    return data.id ? [String(data.id)] : [];
  }

  function getBodyVariantIds(body) {
    if (!body) return [];

    try {
      if (window.FormData && body instanceof FormData) {
        return body.get('id') ? [String(body.get('id'))] : [];
      }

      if (window.URLSearchParams && body instanceof URLSearchParams) {
        return body.get('id') ? [String(body.get('id'))] : [];
      }

      if (typeof body === 'string') {
        if (body.charAt(0) === '{') return idsFromObject(JSON.parse(body));
        var params = new URLSearchParams(body);
        return params.get('id') ? [String(params.get('id'))] : [];
      }
    } catch (error) {
      return [];
    }

    return [];
  }

  function stateMatchesBody(body, state) {
    if (!state || !state.active || !state.text) return false;
    var form = getAddForm(state.productInfo || state.card || document);
    var formId = getFormVariantId(form);
    if (!formId) return true;
    var bodyIds = getBodyVariantIds(body);
    if (!bodyIds.length) return true;
    return bodyIds.indexOf(String(formId)) !== -1;
  }

  function getStateForCartBody(body) {
    if (pendingSubmitState && pendingSubmitState.expiresAt > Date.now() && stateMatchesBody(body, pendingSubmitState.state)) {
      return pendingSubmitState.state;
    }

    var state = getActiveState(document);
    return stateMatchesBody(body, state) ? state : { active: false, text: '' };
  }

  function buildProperties(properties, state) {
    var next = Object.assign({}, properties || {});
    if (state && state.text) next[PROPERTY_NAME] = state.text;
    return next;
  }

  function copyCartSectionFields(from, to) {
    if (!from || !to || !from.get) return to;
    var sections = from.get('sections');
    var sectionsUrl = from.get('sections_url');
    if (sections) to.sections = sections;
    if (sectionsUrl) to.sections_url = sectionsUrl;
    return to;
  }

  function copyJsonCartSectionFields(from, to) {
    if (!from || !to) return to;
    if (from.sections) to.sections = from.sections;
    if (from.sections_url) to.sections_url = from.sections_url;
    return to;
  }

  function cleanOriginalPropertyFields(form) {
    if (!form || !form.querySelectorAll) return;
    form.querySelectorAll('input[name="properties[Custom text]"], textarea[name="properties[Custom text]"], select[name="properties[Custom text]"]').forEach(function(input) {
      input.value = cleanCustomText(input.value);
    });
  }

  function formDataToItems(formData, state) {
    var id = formData.get('id');
    if (!id) return null;

    var quantity = getQuantityFromBody(formData);
    var properties = {};
    formData.forEach(function(value, key) {
      var match = String(key).match(/^properties\[(.*)\]$/);
      if (!match) return;
      var label = match[1];
      var text = String(value || '').trim();
      if (!text || label === PROPERTY_NAME) return;
      properties[label] = text;
    });

    return copyCartSectionFields(formData, {
      items: [
        {
          id: String(id),
          quantity: quantity,
          properties: buildProperties(properties, state)
        },
        {
          id: ADDON_VARIANT_ID,
          quantity: quantity,
          properties: {
            'Custom text': state.text,
            '_KAKAVY add-on': 'Custom text personalization'
          }
        }
      ]
    });
  }

  function jsonToItems(data, state) {
    if (Array.isArray(data.items)) {
      var nextItems = [];
      data.items.forEach(function(item) {
        if (!item) return;
        if (String(item.id || '') === String(ADDON_VARIANT_ID)) return;
        var quantity = Number(item.quantity || 1);
        nextItems.push(Object.assign({}, item, {
          properties: buildProperties(item.properties, state)
        }));
        nextItems.push({
          id: ADDON_VARIANT_ID,
          quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
          properties: {
            'Custom text': state.text,
            '_KAKAVY add-on': 'Custom text personalization'
          }
        });
      });
      return copyJsonCartSectionFields(data, { items: nextItems });
    }

    if (data && data.id) {
      var quantity = Number(data.quantity || 1);
      return copyJsonCartSectionFields(data, {
        items: [
          Object.assign({}, data, {
            sections: undefined,
            sections_url: undefined,
            properties: buildProperties(data.properties, state)
          }),
          {
            id: ADDON_VARIANT_ID,
            quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
            properties: {
              'Custom text': state.text,
              '_KAKAVY add-on': 'Custom text personalization'
            }
          }
        ]
      });
    }

    return data;
  }

  function transformCartAddBody(body, state) {
    if (!state || !state.active || !state.text || !body) return body;

    if (window.FormData && body instanceof FormData) {
      var payload = formDataToItems(body, state);
      return payload ? JSON.stringify(payload) : body;
    }

    if (window.URLSearchParams && body instanceof URLSearchParams) {
      var payloadFromParams = formDataToItems(body, state);
      return payloadFromParams ? JSON.stringify(payloadFromParams) : body;
    }

    if (typeof body === 'string') {
      try {
        if (body.charAt(0) === '{') {
          return JSON.stringify(jsonToItems(JSON.parse(body), state));
        }
        var params = new URLSearchParams(body);
        var payloadFromString = formDataToItems(params, state);
        return payloadFromString ? JSON.stringify(payloadFromString) : body;
      } catch (error) {
        return body;
      }
    }

    return body;
  }

  function headersForJson(init) {
    var headers = new Headers((init && init.headers) || {});
    headers.set('Content-Type', 'application/json');
    if (!headers.get('Accept')) headers.set('Accept', 'application/json');
    return headers;
  }

  async function addCustomizedItemsFromForm(form, state) {
    var formData = new FormData(form);
    var payload = formDataToItems(formData, state);
    if (!payload) return false;

    var sections = [];
    document.dispatchEvent(new CustomEvent('cart:grouped-sections', {
      bubbles: true,
      detail: { sections: sections }
    }));
    if (sections.length) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }

    var response = await fetch((window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) throw new Error('Could not add customized product.');
    var cartJson = await response.json();
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.publish && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
    }
    return true;
  }

  if (window.fetch && !window.KAKAVY_PERSONALIZATION_ADDON_FETCH_V1) {
    window.KAKAVY_PERSONALIZATION_ADDON_FETCH_V1 = true;
    var originalFetch = window.fetch;
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (isCartAddUrl(url) && init && init.body) {
        var state = getStateForCartBody(init.body);
        if (state.active && state.text) {
          init = Object.assign({}, init, {
            headers: headersForJson(init),
            body: transformCartAddBody(init.body, state)
          });
          if (state.input && state.input.value !== state.text) state.input.value = state.text;
        }
      }
      return originalFetch.call(this, input, init);
    };
  }

  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype && !window.KAKAVY_PERSONALIZATION_ADDON_XHR_V1) {
    window.KAKAVY_PERSONALIZATION_ADDON_XHR_V1 = true;
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function(method, url) {
      this.__kakavyAddonCartAddUrl = isCartAddUrl(url);
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function(body) {
      if (this.__kakavyAddonCartAddUrl) {
        var state = getStateForCartBody(body);
        if (state.active && state.text) body = transformCartAddBody(body, state);
      }
      return originalSend.call(this, body);
    };
  }

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) return;
    var state = getActiveState(form);
    if (!state.active || !state.text) return;
    pendingSubmitState = {
      state: state,
      expiresAt: Date.now() + 3000
    };
    cleanOriginalPropertyFields(form);
  }, true);

  document.addEventListener('click', function(event) {
    var trigger = event.target && event.target.closest && event.target.closest('.shopify-payment-button__button, .shopify-payment-button__more-options, shopify-accelerated-checkout, shop-pay-wallet-button');
    if (!trigger) return;

    var state = getActiveState(trigger);
    if (!state.active || !state.text) return;

    var productInfo = state.productInfo || closestProductInfo(trigger);
    var form = (trigger.form || (productInfo && productInfo.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')));
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    addCustomizedItemsFromForm(form, state)
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function(error) {
        console.error(error);
        var input = state.input;
        if (input) {
          input.setCustomValidity('Please try Add To Cart first.');
          input.reportValidity();
          setTimeout(function() { input.setCustomValidity(''); }, 1000);
        }
      });
  }, true);
})();
/* KAKAVY_PERSONALIZATION_ADDON_PRODUCT_MODE_V1_END */

/* KAKAVY_PERSONALIZATION_CART_INTEGRITY_V1_START */
(function() {
  if (window.KAKAVY_PERSONALIZATION_CART_INTEGRITY_V1) return;
  window.KAKAVY_PERSONALIZATION_CART_INTEGRITY_V1 = true;

  var ADDON_VARIANT_ID = '49915109605618';
  var ADDON_TITLE = 'Custom Text Personalization';
  var ADDON_SKU = 'KAKAVY-CUSTOM-TEXT';
  var PROPERTY_LABEL = 'Custom text';
  var ADDON_PROPERTY_LABEL = '_KAKAVY add-on';
  var ADDON_PROPERTY_VALUE = 'Custom text personalization';
  var syncing = false;
  var queued = false;
  var syncTimer = null;
  var lastSyncAt = 0;

  function isCartMutationUrl(url) {
    return /\/cart\/(change|update|clear|add)(\.js)?/i.test(String(url || ''));
  }

  function getProperty(item, label) {
    var properties = item && item.properties;
    if (!properties) return '';
    if (Array.isArray(properties)) {
      for (var i = 0; i < properties.length; i += 1) {
        if (properties[i] && properties[i].name === label) return String(properties[i].value || '').trim();
      }
      return '';
    }
    return String(properties[label] || '').trim();
  }

  function hasCustomText(item) {
    var feeIncluded = getProperty(item, '_KAKAVY fee included');
    if (/^(true|yes|1)$/i.test(feeIncluded)) return false;
    var text = getProperty(item, PROPERTY_LABEL);
    return Boolean(text && !/^no custom text$/i.test(text));
  }

  function customText(item) {
    return getProperty(item, PROPERTY_LABEL);
  }

  function isAddonLine(item) {
    return String(item && item.variant_id || '') === String(ADDON_VARIANT_ID) ||
      String(item && item.sku || '') === ADDON_SKU ||
      String(item && item.product_title || '').trim() === ADDON_TITLE;
  }

  function normalizeText(text) {
    return String(text || '').trim();
  }

  function addToMap(map, key, quantity) {
    key = normalizeText(key);
    if (!key) return;
    map[key] = (map[key] || 0) + Math.max(0, Number(quantity || 0));
  }

  async function cartJson(path, body) {
    var response = await fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body || {})
    });
    if (!response.ok) throw new Error('Could not update personalized cart.');
    return response.json();
  }

  async function getCart() {
    var response = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Could not read cart.');
    return response.json();
  }

  async function addAddon(text, quantity) {
    if (!quantity || quantity < 1) return null;
    return cartJson('/cart/add.js', {
      items: [{
        id: ADDON_VARIANT_ID,
        quantity: quantity,
        properties: {
          'Custom text': text,
          '_KAKAVY add-on': ADDON_PROPERTY_VALUE
        }
      }]
    });
  }

  async function changeLine(key, quantity) {
    if (!key) return null;
    return cartJson('/cart/change.js', {
      id: key,
      quantity: Math.max(0, Number(quantity || 0))
    });
  }

  function summarizeCart(cart) {
    var required = {};
    var addonByText = {};
    var addonLines = [];

    (cart.items || []).forEach(function(item) {
      var text = customText(item);
      if (isAddonLine(item)) {
        var addonText = normalizeText(text);
        addonLines.push({
          key: item.key,
          text: addonText,
          quantity: Number(item.quantity || 0)
        });
        if (addonText) addToMap(addonByText, addonText, item.quantity);
        return;
      }

      if (hasCustomText(item)) {
        addToMap(required, text, item.quantity);
      }
    });

    return {
      required: required,
      addonByText: addonByText,
      addonLines: addonLines
    };
  }

  async function enforceCartIntegrity() {
    if (syncing) {
      queued = true;
      return false;
    }

    syncing = true;
    queued = false;
    document.documentElement.setAttribute('data-kakavy-cart-integrity-active', 'true');
    var changed = false;

    try {
      var cart = await getCart();
      var summary = summarizeCart(cart);

      for (var i = summary.addonLines.length - 1; i >= 0; i -= 1) {
        var addonLine = summary.addonLines[i];
        if (!addonLine.text || !summary.required[addonLine.text]) {
          await changeLine(addonLine.key, 0);
          changed = true;
        }
      }

      cart = changed ? await getCart() : cart;
      summary = summarizeCart(cart);

      var requiredTexts = Object.keys(summary.required);
      for (var t = 0; t < requiredTexts.length; t += 1) {
        var text = requiredTexts[t];
        var requiredQuantity = summary.required[text] || 0;
        var addonQuantity = summary.addonByText[text] || 0;

        if (addonQuantity < requiredQuantity) {
          await addAddon(text, requiredQuantity - addonQuantity);
          changed = true;
          continue;
        }

        if (addonQuantity > requiredQuantity) {
          var surplus = addonQuantity - requiredQuantity;
          var matching = summary.addonLines.filter(function(line) { return line.text === text; });
          for (var m = matching.length - 1; m >= 0 && surplus > 0; m -= 1) {
            var reduceBy = Math.min(surplus, matching[m].quantity);
            await changeLine(matching[m].key, matching[m].quantity - reduceBy);
            surplus -= reduceBy;
            changed = true;
          }
        }
      }

      if (changed) {
        var freshCart = await getCart();
        publishCartUpdate(freshCart);
      }

      lastSyncAt = Date.now();
      markAddonRows();
      return changed;
    } finally {
      syncing = false;
      document.documentElement.removeAttribute('data-kakavy-cart-integrity-active');
      document.documentElement.removeAttribute('data-kakavy-cart-integrity-pending');
      if (queued) {
        queued = false;
        setTimeout(enforceCartIntegrity, 80);
      }
    }
  }

  function publishCartUpdate(cart) {
    document.dispatchEvent(new CustomEvent('kakavy:cart-integrity-updated', {
      bubbles: true,
      detail: { cart: cart }
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: cart } }));

    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.publish && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
    }
  }

  function scheduleIntegrityCheck(delay) {
    document.documentElement.setAttribute('data-kakavy-cart-integrity-pending', 'true');
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function() {
      enforceCartIntegrity().catch(function(error) {
        console.error(error);
        document.documentElement.removeAttribute('data-kakavy-cart-integrity-pending');
      });
    }, delay == null ? 180 : delay);
  }

  function markAddonRows() {
    var candidates = document.querySelectorAll('cart-item, .cart-item, tr, li, .drawer__cart-item, .cart-drawer__item, [data-cart-item], .cart-items__item');
    candidates.forEach(function(row) {
      var text = String(row.textContent || '');
      if (text.indexOf(ADDON_TITLE) === -1 && text.indexOf(ADDON_SKU) === -1) return;
      row.setAttribute('data-kakavy-addon-line', 'true');
      row.querySelectorAll('cart-remove-button, .cart-remove-button, .cart-item__remove, a[href*="/cart/change"], button, input, select, quantity-input, .quantity').forEach(function(control) {
        control.setAttribute('data-kakavy-addon-control', 'true');
        control.setAttribute('aria-hidden', 'true');
        control.style.pointerEvents = 'none';
        control.style.opacity = '0.45';
      });
    });
  }

  function installStyle() {
    if (document.getElementById('kakavy-cart-integrity-style')) return;
    var style = document.createElement('style');
    style.id = 'kakavy-cart-integrity-style';
    style.textContent = [
      '[data-kakavy-addon-line="true"] cart-remove-button,',
      '[data-kakavy-addon-line="true"] .cart-remove-button,',
      '[data-kakavy-addon-line="true"] .cart-item__remove,',
      '[data-kakavy-addon-line="true"] a[href*="/cart/change"],',
      '[data-kakavy-addon-line="true"] quantity-input,',
      '[data-kakavy-addon-line="true"] .quantity,',
      '[data-kakavy-addon-control="true"] { display: none !important; pointer-events: none !important; opacity: .45 !important; }',
      'html[data-kakavy-cart-integrity-pending="true"] button[name="checkout"],',
      'html[data-kakavy-cart-integrity-active="true"] button[name="checkout"],',
      'html[data-kakavy-cart-integrity-pending="true"] input[name="checkout"],',
      'html[data-kakavy-cart-integrity-active="true"] input[name="checkout"],',
      'html[data-kakavy-cart-integrity-pending="true"] .cart__checkout-button,',
      'html[data-kakavy-cart-integrity-active="true"] .cart__checkout-button,',
      'html[data-kakavy-cart-integrity-pending="true"] .shopify-payment-button,',
      'html[data-kakavy-cart-integrity-active="true"] .shopify-payment-button,',
      'html[data-kakavy-cart-integrity-pending="true"] shop-pay-wallet-button,',
      'html[data-kakavy-cart-integrity-active="true"] shop-pay-wallet-button { pointer-events: none !important; opacity: .55 !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function shouldHandleCheckoutClick(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    return target.closest('button[name="checkout"], input[name="checkout"], .cart__checkout-button, a[href="/checkout"], a[href*="/checkout"], form[action*="/checkout"] button[type="submit"], .shopify-payment-button, shop-pay-wallet-button, [data-shopify="payment-button"]');
  }

  document.addEventListener('click', function(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var addonRow = target.closest('[data-kakavy-addon-line="true"]');
    if (!addonRow) return;
    if (target.closest('button, a, input, select, quantity-input, cart-remove-button, .quantity')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      markAddonRows();
    }
  }, true);

  function routeCheckout(trigger) {
    var form = trigger && trigger.form;
    if (form && /\/checkout/i.test(String(form.getAttribute('action') || ''))) {
      form.setAttribute('data-kakavy-integrity-ready', 'true');
      form.submit();
      return;
    }
    window.location.href = '/checkout';
  }

  if (window.fetch && !window.KAKAVY_PERSONALIZATION_CART_INTEGRITY_FETCH_V1) {
    window.KAKAVY_PERSONALIZATION_CART_INTEGRITY_FETCH_V1 = true;
    var originalFetch = window.fetch;
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      return originalFetch.apply(this, arguments).then(function(response) {
        if (isCartMutationUrl(url) && !syncing) scheduleIntegrityCheck();
        return response;
      });
    };
  }

  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype && !window.KAKAVY_PERSONALIZATION_CART_INTEGRITY_XHR_V1) {
    window.KAKAVY_PERSONALIZATION_CART_INTEGRITY_XHR_V1 = true;
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function(method, url) {
      this.__kakavyCartIntegrityUrl = isCartMutationUrl(url);
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function() {
      if (this.__kakavyCartIntegrityUrl) {
        this.addEventListener('loadend', function() {
          if (!syncing) scheduleIntegrityCheck();
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  document.addEventListener('click', function(event) {
    var trigger = shouldHandleCheckoutClick(event);
    if (!trigger || trigger.getAttribute('data-kakavy-integrity-ready') === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    enforceCartIntegrity()
      .then(function() { routeCheckout(trigger); })
      .catch(function(error) {
        console.error(error);
        window.location.href = '/cart';
      });
  }, true);

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !/\/checkout/i.test(String(form.getAttribute('action') || ''))) return;
    if (form.getAttribute('data-kakavy-integrity-ready') === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    enforceCartIntegrity()
      .then(function() {
        form.setAttribute('data-kakavy-integrity-ready', 'true');
        form.submit();
      })
      .catch(function(error) {
        console.error(error);
        window.location.href = '/cart';
      });
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    installStyle();
    markAddonRows();
    if (Date.now() - lastSyncAt > 2000) scheduleIntegrityCheck(250);
  });

  document.addEventListener('shopify:section:load', function(event) {
    installStyle();
    markAddonRows();
    scheduleIntegrityCheck(250);
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function() {
      installStyle();
      markAddonRows();
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }
  }

  installStyle();
  markAddonRows();
  scheduleIntegrityCheck(300);
})();
/* KAKAVY_PERSONALIZATION_CART_INTEGRITY_V1_END */




